document.addEventListener('DOMContentLoaded', function () {
  initGaleria();
  initSelectorVariantes();
  initEventosAnuncios();
});

/* Eventos de píxeles de publicidad (TikTok, Meta) en la página de producto */
function initEventosAnuncios() {
  var formularios = document.querySelectorAll('[data-mt-form-producto]');
  formularios.forEach(function (form) {
    var contenedor = form.closest('.mt-compra');
    var productoId = contenedor ? contenedor.getAttribute('data-mt-producto-id') : null;
    var productoTitulo = contenedor ? contenedor.getAttribute('data-mt-producto-titulo') : null;
    var moneda = (contenedor && contenedor.getAttribute('data-mt-producto-moneda')) || 'USD';
    var seccion = form.closest('section');
    var precioEl = seccion ? seccion.querySelector('.mt-precio span') : null;
    var precioActual = precioEl ? parseFloat(precioEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.')) : null;

    // Vista de producto
    if (window.ttq && productoId) {
      ttq.track('ViewContent', {
        content_id: productoId,
        content_name: productoTitulo,
        currency: moneda,
        value: precioActual
      });
    }

    // Añadir al carrito
    form.addEventListener('submit', function () {
      if (!window.ttq || !productoId) return;
      var precioSpan = seccion ? seccion.querySelector('.mt-precio span') : null;
      var precioEnvio = precioSpan ? parseFloat(precioSpan.textContent.replace(/[^0-9.,]/g, '').replace(',', '.')) : precioActual;
      ttq.track('AddToCart', {
        content_id: productoId,
        content_name: productoTitulo,
        currency: moneda,
        value: precioEnvio
      });
    });
  });
}

function initGaleria() {
  var miniaturas = document.querySelectorAll('[data-mt-miniatura]');
  if (!miniaturas.length) return;

  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var contenedor = btn.closest('.mt-galeria');
      if (!contenedor) return;
      var principal = contenedor.querySelector('.mt-galeria-principal img');
      if (!principal) return;

      miniaturas.forEach(function (b) {
        b.classList.remove('mt-miniatura-activa');
        b.style.borderColor = 'var(--mt-color-borde)';
      });
      btn.classList.add('mt-miniatura-activa');
      btn.style.borderColor = 'var(--mt-color-azul)';

      var src = btn.getAttribute('data-mt-src');
      if (src) principal.setAttribute('src', src);
    });
  });
}

function initSelectorVariantes() {
  var formularios = document.querySelectorAll('[data-mt-form-producto]');
  formularios.forEach(function (form) {
    var seccion = form.closest('section');
    if (!seccion) return;

    var variantesScript = seccion.querySelector('[data-mt-variantes]');
    if (!variantesScript) return;

    var variantes;
    try {
      variantes = JSON.parse(variantesScript.textContent);
    } catch (e) {
      return;
    }

    var grupos = seccion.querySelectorAll('[data-mt-opcion-grupo]');
    var idInput = form.querySelector('input[name="id"]');
    var botonComprar = seccion.querySelector('[id^="mt-boton-comprar-"]');
    var botonTexto = seccion.querySelector('[data-mt-boton-texto]');
    var precioEl = seccion.querySelector('.mt-precio');

    function seleccionActual() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.mt-opcion-activa');
        seleccion.push(activo ? activo.getAttribute('data-mt-opcion-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante(seleccion) {
      return variantes.find(function (v) {
        var opciones = [v.option1, v.option2, v.option3];
        return seleccion.every(function (val, i) { return val === null || opciones[i] === val; });
      });
    }

    function actualizar() {
      var seleccion = seleccionActual();
      var variante = encontrarVariante(seleccion);
      if (!variante) return;

      if (idInput) idInput.value = variante.id;

      if (precioEl) {
        var spanPrecio = precioEl.querySelector('span');
        if (spanPrecio && variante.price !== undefined) {
          spanPrecio.textContent = formatoDinero(variante.price);
        }
      }

      if (botonComprar) {
        if (variante.available) {
          botonComprar.removeAttribute('disabled');
          if (botonTexto) botonTexto.textContent = botonComprar.getAttribute('data-mt-texto-disponible') || botonTexto.textContent;
        } else {
          botonComprar.setAttribute('disabled', 'disabled');
          if (botonTexto) botonTexto.textContent = botonComprar.getAttribute('data-mt-texto-agotado') || 'Agotado';
        }
      }
    }

    function formatoDinero(precioEnCentavos) {
      var numero = parseFloat(precioEnCentavos);
      if (isNaN(numero)) return precioEnCentavos;
      numero = numero / 100;
      return '$' + numero.toFixed(2);
    }

    grupos.forEach(function (grupo) {
      var botones = grupo.querySelectorAll('[data-mt-opcion-valor]');
      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          botones.forEach(function (b) {
            b.classList.remove('mt-opcion-activa');
            b.style.borderColor = 'var(--mt-color-borde)';
          });
          btn.classList.add('mt-opcion-activa');
          btn.style.borderColor = 'var(--mt-color-texto)';
          actualizar();
        });
      });
    });
  });
}
